<template>
    <div style="line-height: 1" class="card carde w3-animate-opacity mb-0" :class="fullscreen ? 'leorad-fullscreen' : ''">
        <div class="card-header d-flex justify-content-between align-items-center bg-white" v-if="fullscreen">
            <div>
                <h5 class="strong" >{{ paciente }}</h5>
            </div>
            <div>
                <slot name="buttons"></slot>
                <a href="#" class="btn btn-light btn-sm ml-3" @click.prevent="toggle_fullscreen()">
                    <i class="fas fa-compress-alt" v-if="fullscreen"></i>
                    <i class="fas fa-expand-alt" v-else></i>    
                </a>
            </div>
        </div>
        <iframe
            v-show="url"
            style="width: 100%;" :style="'height: calc(100vh - ' + ( (posx && !fullscreen) ? posx : '65' ) + 'px);'"
            id="leorad"
            scrolling="no"
            allow="clipboard-write; microphone; fullscreen; encrypted-media"
            :src="url" />

        <template v-if="!url">
            <az-empty-state />
        </template>
    </div>
</template>

<script>
// import CryptoJS from 'crypto-js';
// import moment from 'moment';
import AzEmptyState from "../../util/AzEmptyState.vue";

export default {
    data() {
        return {
        };
    },

    props: ["company_token", "url", "content", "posx", "fullscreen", "paciente"],

    components: {
        AzEmptyState
    },

    methods: {

        toggle_fullscreen() {
            this.$emit("toggle");
        },

        setContent() {
            let leoradIfr = document.getElementById("leorad").contentWindow;

            let data = {
                action: "setContent",
                data: this.content ? this.content : ''
            };

            console.log("setContent", data);

            leoradIfr.postMessage(data, "https://app.leorad.com.br");
        },

        registraEventos() {
            // Atribuir "handler" para o evento "message"
            if (window.addEventListener) {
                window.addEventListener(
                    "message",
                    this.handlePostMessage,
                    false
                );
            } else if (window.attachEvent) {
                // ie8
                window.attachEvent("onmessage", this.handlePostMessage);
            }
        },

        handlePostMessage(evento) {
            if (evento.origin === "https://app.leorad.com.br") {

                console.log("Evento", evento);

                // Checar ações da post messagem
                const { action, data } = evento.data;

                switch (action) {
                    case "loaded":
                        this.setContent();    
                        break;

                    case "getContent":
                        this.$emit("salvarLaudo", data);
                        break;

                    // case "nextReport":
                    //     this.$emit("salvarLaudoNext", data);
                    //     break;

                    // case "textChange":
                    //     this.$emit("autoSave", data);
                    //     break;

                    default:
                        // console.log(action, data);
                        break;
                }
            }
        }
    },

    mounted() {
        this.registraEventos();
    },

    destroyed() {
        if (window.addEventListener) {
            window.removeEventListener("message", this.handlePostMessage);
        } else if (window.attachEvent) {
            window.detachEvent("onmessage", this.handlePostMessage);
        }
    }
};
</script>

<style scoped>
.leorad-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 150px;
  overflow: auto;
}
</style>